<template>
  <Checkbox
    v-if="params.data.custCostType != null"
    v-model="checked"
    size="small"
    :disabled="params.disabled"
    :binary="true"
    class="mb-1"
    @change="params.setCutChecks(params.data.drawItemId, checked)"
  />
</template>

<script setup lang="ts">
//TODO: MAKE THIS GENERALIZED???

const props = defineProps(["params"]);

const checked = ref(props.params.data.cutChecks);
</script>
